<template>
    <v-dialog v-model="dialog" persistent width="500px" style="background-color: #fff" @keydown.esc="chiudi()">

        <v-card style="background-color: #fff">
            <v-card-title>
                Nuovo cliente potenziale
                <v-spacer />
                <v-btn icon @click="chiudi()"> <v-icon>close</v-icon> </v-btn>
            </v-card-title>

            <v-card-text>
                <v-text-field label="Ragione sociale" v-model="dati.ragioneSociale" />
                <v-text-field label="Telefono" v-model="dati.telefono" />
                <v-text-field label="E-Mail" v-model="dati.email" />
                <v-text-field label="Partita IVA" v-model="dati.partitaIva" />
                <v-select :items="tipoClienti" label="Tipo cliente" v-model="dati.tipoCliente" />

                <div>
                    <div class="d-flex align-center justify-space-between">
                        <h3 class="subtitle-1 font-weight-bold">Indirizzi</h3>
                        <v-btn icon @click="addIndirizzo">
                            <v-icon>add</v-icon>
                        </v-btn>
                    </div>

                    <div v-for="(indirizzo, i) in dati.indirizzi" :key="i" class="d-flex">
                        <v-text-field v-model="dati.indirizzi[i]" :label="'Indirizzo ' + (i + 1)" class="flex-grow-1"
                            hide-details />

                        <v-btn icon color="red" @click="removeIndirizzo(i)" v-if="dati.indirizzi.length > 1"
                            class="mt-2">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </div>
                </div>

                <v-textarea label="Note" rows="4" v-model="dati.note" />
            </v-card-text>


            <v-card-actions>
                <v-spacer />
                <v-btn @click.prevent="conferma()" color="primary">conferma</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { get_tipoClienti, set_clientePotenziale } from "@/api/api.agenti.js";

export default {

    props: {
        dialog: { type: Boolean, default: false }
    },

    data: () => ({
        dati: {
            indirizzi: [""],
        },
        tipoClienti: [],
    }),

    methods: {
        chiudi(aggiorna) {
            this.$emit("chiudiDialog", aggiorna);
        },

        async caricaDati() {
            this.dati = { indirizzi: [""], };
            let res = await get_tipoClienti();
            this.tipoClienti = res.data;
        },

        addIndirizzo() {
            this.dati.indirizzi.push("");
        },
        removeIndirizzo(index) {
            this.dati.indirizzi.splice(index, 1);
        },

        async conferma() {
            let par = "";
            let userSwitch = this.$store.getters["user/getUserSwitch"];
            if (userSwitch.Codice) par = userSwitch.Tipo + "/" + userSwitch.Codice;
            let res = await set_clientePotenziale(par, this.dati);
            if (res.data == "OK") {
                this.$toast.info("Dati salvati");
                this.chiudi(true);
            }
            else {
                this.$toast.alert(res.data);
            }
        }
    },

    watch: {
        dialog(val) {
            if (val) {
                this.caricaDati();
            }
        }
    }
}

</script>